import type { PropRule } from './analytics-types.js';

export function mapRouteEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const route = { ...common, reason: new Set(['http', 'network', 'no_route', 'invalid_response', 'unknown', 'changed']), operation: new Set(['create', 'edit']), mode: new Set(['driving', 'walking', 'cycling']), stops: /^[0-9]{1,4}$/ };
  return {
    map_route_opened: route,
    map_route_preview_ready: { ...route, first_preview: new Set(['true', 'false']), duration_ms: /^[0-9]{1,6}$/ },
    map_route_calculation_failed: { ...route, http_status: /^[1-5][0-9]{2}$/, provider_code: new Set(['NoSegment', 'NoRoute', 'InvalidUrl', 'InvalidService', 'InvalidVersion', 'InvalidOptions', 'InvalidQuery', 'InvalidValue', 'TooBig']), stop_index: /^[0-9]{1,4}$/, diagnostic: new Set(['provider_response', 'empty_routes', 'waypoint_mismatch', 'invalid_geometry', 'invalid_json']), reason: new Set(['http', 'network', 'no_route', 'invalid_response', 'unknown']), duration_ms: /^[0-9]{1,6}$/ },
    map_route_retried: route,
    map_route_stop_changed: { ...route, action: new Set(['search', 'map', 'add', 'remove', 'reorder']) },
    map_route_mode_changed: route,
    map_route_added: route,
    map_route_updated: route,
    map_route_cancelled: { ...route, preview_ready: new Set(['true', 'false']) },
    map_route_commit_failed: { ...route, reason: new Set(['changed']) },
  };
}
